

export const FETCH_PRODUCTS_REQUEST = "FETCH_PRODUCTS_REQUEST"
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS"
export const FETCH_PRODUCTS_FAILED = "FETCH_PRODUCTS_FAILED"


export const FETCH_DELETED_PRODUCTS_REQUEST = "FETCH_DELETED_PRODUCTS_REQUEST"
export const FETCH_DELETED_PRODUCTS_SUCCESS = "FETCH_DELETED_PRODUCTS_SUCCESS"
export const FETCH_DELETED_PRODUCTS_FAILED = "FETCH_DELETED_PRODUCTS_FAILED"


export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAILED = "UPDATE_PRODUCT_FAILED"


export const FETCH_CATEGORIES_REQUEST = "FETCH_CATEGORIES_REQUEST"
export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS"
export const FETCH_CATEGORIES_FAILED = "FETCH_CATEGORIES_FAILED"

export const ADD_CATEGORY_REQUEST = "ADD_CATEGORY_REQUEST"
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS"
export const ADD_CATEGORY_FAILED = "ADD_CATEGORY_FAILED"






